import { Button } from 'react-bootstrap';
import React, { useCallback, useRef } from 'react';

import './upload-field.css';

export function UploadField(props) {
    const { fileType, onChange } = props;
    const ref = useRef();
    const handleBtnClick = useCallback(() => {
        if (ref.current) ref.current.click();
    }, [ref]);
    return (
        <>
            <input
                type="file"
                multiple
                id={`file-input-${fileType.id}`}
                className="file-input"
                onChange={e => onChange(e, fileType)}
                ref={ref}
            />
            <Button variant="outline-primary" className="px-4 position-relative" onClick={handleBtnClick}>
                Добавить файл
            </Button>
        </>
    );
}
